// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__M5S_i","row":"styles_row__3XJn6"};